export const CUSTOM_DOTS_STYLE = "w-full h-full rounded-full";
